import Marquee from "react-fast-marquee";
import { useContent } from "@/context/ContentContext";

export const EditorialMarquee = () => {
  const items = useContent().marquee.items;
  return (
    <section data-testid="marquee-section" className="bg-ink py-20 md:py-28 border-y border-white/10 overflow-hidden">
      <Marquee speed={30} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="font-display text-6xl sm:text-8xl lg:text-9xl font-extrabold tracking-tight text-stroke mx-8 select-none">
            {t} <span className="text-gold/30 mx-4">•</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
